import { MdrContactDetailsFormWebComponent } from './component/MdrContactDetailsFormWebComponent';
import { WEB_COMPONENT_MDR_CONTACT_DETAILS_FORM } from '../../../../webcomponents.constants';

export { MdrContactDetailsFormWebComponent };

window.customElements.define(WEB_COMPONENT_MDR_CONTACT_DETAILS_FORM, MdrContactDetailsFormWebComponent);
